module.exports = "<div>\r\n\t<div class=\"admin-login-panel\" *ngIf=\"isVisible\" (click)=\"getBackToAdminAccount()\">\r\n\t\t<p>You are logged in as admin</p>\r\n\t\t<p>Click to get back to {{admin.name}}</p>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/admin-login-panel.component.html
// module id = 521
// module chunks = 0